var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"header-wrapper flex-container small-align-center small-align-middle"},[_c('router-link',{staticClass:"action close",attrs:{"to":{name: 'home'}}},[_c('i',{staticClass:"icon-close"})]),_c('logo')],1)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }